/** Trim text to max length on word boundary when possible. */
export function trimTo(text, maxLen = 160) {
  const s = String(text ?? '').trim();
  if (!s || s.length <= maxLen) return s;
  const slice = s.slice(0, maxLen);
  const lastSpace = slice.lastIndexOf(' ');
  if (lastSpace > maxLen * 0.6) return `${slice.slice(0, lastSpace).trim()}…`;
  return `${slice.trim()}…`;
}

/** `bachupally` → `Bachupally`, `tellapur` → `Tellapur` */
export function humanizeSlug(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  return raw
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : ''))
    .join(' ')
    .trim();
}

export function formatPlaceLabel(locality, city) {
  const loc = String(locality ?? '').trim() || humanizeSlug(locality);
  const c = String(city ?? '').trim() || humanizeSlug(city);
  if (loc && c && loc.toLowerCase() !== c.toLowerCase()) return `${loc}, ${c}`;
  return loc || c || '';
}

/** Normalize BHK string for titles — "2, 3 BHK" style. */
export function formatBhkForTitle(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  if (/bhk/i.test(s)) return s.replace(/\s*,\s*/g, ', ');
  const nums = s.match(/\d+/g);
  if (nums?.length) {
    const unique = [...new Set(nums)];
    return unique.length === 1 ? `${unique[0]} BHK` : `${unique.join(', ')} BHK`;
  }
  return s;
}

const TRACKING_PARAMS = new Set([
  '_map_refresh',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'fbclid',
  'gclid',
]);

/** Build query string from params object, stripping tracking keys. */
export function buildCanonicalQuery(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (TRACKING_PARAMS.has(k)) return;
    if (v != null && String(v).trim() !== '') qs.set(k, String(v).trim());
  });
  const q = qs.toString();
  return q ? `?${q}` : '';
}

export function parseSearchParams(search = '') {
  const raw = String(search || '').replace(/^\?/, '');
  return new URLSearchParams(raw);
}

const PROPERTY_LABELS = {
  apartment: { singular: 'apartment', plural: 'apartments', capital: 'Apartments' },
  villa: { singular: 'villa', plural: 'villas', capital: 'Villas' },
  plot: { singular: 'plot', plural: 'plots', capital: 'Plots' },
};

export function getPropertyTypeLabels(propertyType = 'apartment') {
  const t = String(propertyType || 'apartment').toLowerCase();
  if (t === 'villa') return PROPERTY_LABELS.villa;
  if (t === 'plot') return PROPERTY_LABELS.plot;
  return PROPERTY_LABELS.apartment;
}
